import type { Mapping } from '@pn/core/domain/data';
import { setFields } from '@pn/resources/pn-mappings';

import companiesOverview from './companies_overview.jsonc';
import companyMonthlyStats from './company_monthly_gross_stats.jsonc';
import formationMonthlyStats from './formation_monthly_stats.jsonc';
import publicCompanyQuarterlyStats from './public_company_quarterly_stats.jsonc';

const intelStatsMappings: Record<string, Mapping> = setFields({
  public_company_quarterly_stats: publicCompanyQuarterlyStats,
  company_monthly_stats: companyMonthlyStats,
  companies_overviews: companiesOverview,
  formation_monthly_stats: formationMonthlyStats,
});

export const publicCompanyQuarterlyStatsMapping =
  intelStatsMappings['public_company_quarterly_stats'];

export const companyMonthlyStatsMapping =
  intelStatsMappings['company_monthly_stats'];

export const formationMonthlyStatsMapping =
  intelStatsMappings['formation_monthly_stats'];

export const companiesOverviewMapping =
  intelStatsMappings['companies_overviews'];
